export default __webpack_public_path__ + "static/11-1a315d5273fc3dc30a2642bfe9b50899.png";